// values here are only used for type inference
// feature flags are created in the LaunchDarkly dashboard

export const featureFlags = {
    'enable-shared-syncer': false,
    'enable-delegation': false,
    'enable-ephemeral-key-solicitations': false,
    'transfer-erc20': false,
    'top-staked-explore': false,
    'enable-explore-v2': false,
    'enable-space-metadata-v2': false,
    'enable-miniapps': false,
    'enable-usdc': false,
    'enable-dm-tips': false,
    'enable-live-ui': false,
    'enable-bot-dm': false,
}
